import React from "react";
import "./personProfileStyle.css";

class Attribute extends React.Component {
  noEdit = {
    createdAt: true,
    updatedAt: true,
  };
  onTrigger = (event) => {
    this.props.parentCallback(event.target.myname.value);
    event.preventDefault();
  };
  renderValue = (val) => {
    val = "" + val;
    if (this.noEdit[this.props.label] || this.props.noEdit) {
      return (
        <div style={{ width: "100%", display: 'flex' }}>
          <span style={{ flex: 0.7 }} className="attributeLabel">{this.props.label}</span>

          <div style={{ flex: 1, display: 'flex' }}>
            <span
              className="attributeLabel"
              style={{ marginRight: "9px", marginLeft: "3%" }}
            >
              :
            </span>
            <span className="ml-2"></span>
            <div className="valueW attributeValue " style={{ marginLeft: "12px" }}>
              {this.props.value}
            </div>

          </div>
        </div>
      );
    } else if (val && (val == "Active" || val.toLowerCase() == "subscribe")) {
      return (
        <div style={{ width: "100%", display: 'flex' }}>
          <span style={{ flex: 0.75 }} className="attributeLabel">{this.props.label}</span>

          <div style={{ flex: 1, display: 'flex' }}>
            <span className="attributeLabel" style={{ marginRight: "15px" }}>
              :
            </span>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div className="wrapp" style={{ display: 'flex' }}>
                <input
                  style={{
                    marginTop: '7px',
                    marginRight: '7px',
                  }}
                  type="radio"
                  className="kw_radio"
                  id="l1"
                  name="drone"
                  value="Subscribed"
                  checked={true}
                  onChange={(e) => {
                    this.props.fun("Active", this.props.label, this.props.side);
                  }}
                />
                <label
                  for="l1" className="activeCheck attributeValue" checked>
                  Subscribed
                </label>
              </div>

              <div className="wrapp" style={{ display: 'flex' }}>
                <input
                  style={{
                    marginTop: '7px',
                    marginRight: '7px',
                  }}
                  type="radio"
                  className="kw_radio"
                  id="l2"
                  name="drone"
                  value="Unsubscribed"
                  onChange={(e) => {
                    this.props.fun("inActive", this.props.label, this.props.side);
                  }}
                />
                <label for="l2" className="attributeValue">
                  Unsubscribed
                </label>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (
      val &&
      (val == "inActive" || val.toLowerCase() == "unsubscribe")
    ) {
      return (
        <div style={{ width: "100%", display: 'flex' }}>
          <span style={{ flex: 0.75 }} className="attributeLabel">{this.props.label}</span>

          <div style={{ flex: 1, display: 'flex' }}>
            <span className="attributeLabel" style={{ marginRight: "15px" }}>
              :
            </span>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div className="wrapp" style={{ display: 'flex' }}>
                <input
                  style={{
                    marginTop: '7px',
                    marginRight: '7px',
                  }}
                  type="radio"
                  className="kw_radio"
                  id="l1"
                  name="drone"
                  value="Subscribed"
                  onChange={(e) => {
                    this.props.fun("Active", this.props.label, this.props.side);
                  }}
                />
                <label
                  for="l1" className="activeCheck attributeValue" >
                  Subscribed
                </label>
              </div>

              <div className="wrapp" style={{ display: 'flex' }}>
                <input
                  style={{
                    marginTop: '7px',
                    marginRight: '7px',
                  }}
                  type="radio"
                  className="kw_radio"
                  id="l2"
                  name="drone"
                  value="Unsubscribed"
                  checked={true}

                  onChange={(e) => {
                    this.props.fun("inActive", this.props.label, this.props.side);
                  }}
                />
                <label for="l2" className="attributeValue" checked>
                  Unsubscribed
                </label>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      let s = {
        border: "1px solid rgba(0,0,0,0.2)",
        borderRadius: "5px",

        backgroundColor: "rgba(0,150,150,0.02)",
        height: "40px",
        padding: "10px",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        cursor: "pointer",
        margin: "0px",
      }
      return (
        <div style={{ width: "100%", display: 'flex' }}>
          <span style={{ flex: 0.7, marginTop: '5px' }} className="attributeLabel">{this.props.label}</span>

          <div style={{ flex: 1, display: 'flex' }}>
            <span
              className="attributeLabel"
              style={{ marginRight: "9px", marginLeft: "3%", marginTop: "5px" }}
            >
              :
            </span>
            <span className={this.props.dollar ? "ml-1" : "ml-2"}></span>
            {this.props.dollar && <span className='mt-2 mr-1'>$</span>}
            <input
              id="audienceName"
              value={this.props.value}
              checked={this.props.value}
              onChange={(e) => {
                let val = this.props.type == 'boolean' ? e.target.checked : e.target.value

                this.props.fun(val, this.props.label, this.props.side);
              }}
              type={this.props.type == 'boolean' ? 'checkbox' : this.props.type}

              //  type="text"
              className="valueW attributeValue"
              style={
                this.props.type == 'boolean' ? {
                  ...s,
                  marginLeft: '13px',
                  width: '6%'
                } :
                  s
              }
            />
          </div>
        </div>
      );
    }
  };

  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          margin: "5px",
          paddingBottom: "20px",
          ...this.props.style
        }}
      >

        {this.renderValue(this.props.value)}

      </div>
    );
  }
}
export default Attribute;